import { RetryLink } from '@apollo/client/link/retry';

export const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: false,
  },
  attempts: {
    max: 2,
    retryIf: (error) => !!error,
  },
});
